import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { ISelfServeBrandOrder } from "@faire/web-api--source/indigofair/helpcenter/ISelfServeBrandOrder";
import React from "react";

import { OrderItemCardWrapper } from "../../components/OrderItemCard";

interface INotRelatedToOrderButtonConditionallyProps {
  focused: boolean;
  brandOrders: ISelfServeBrandOrder[];
  searchText: string;
  onClick: () => void;
}
export const NotRelatedToOrderButtonConditionally: React.FC<
  INotRelatedToOrderButtonConditionallyProps
> = ({ focused, brandOrders, searchText, onClick }) => {
  return brandOrders.length === 1 && searchText === "" && !focused ? (
    <NotRelatedToOrderButton onClick={onClick} />
  ) : null;
};

interface INotRelatedToOrderButtonProps {
  onClick: () => void;
}

const NotRelatedToOrderButton: React.FC<INotRelatedToOrderButtonProps> = ({
  onClick,
}) => {
  return (
    <OrderItemCardWrapper onClick={onClick}>
      <Typography variant="subheadingSansMedium">
        <StrictLocalMsg defaultMessage="No, it's not related to an order" />
      </Typography>
    </OrderItemCardWrapper>
  );
};
